export const TEST_ID = 'activityCardItems';
